import { render, staticRenderFns } from "./BookerOverview.vue?vue&type=template&id=3a4970dc"
import script from "./BookerOverview.vue?vue&type=script&lang=js"
export * from "./BookerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports